export default "__VITE_ASSET__2EwbY6EB__"